import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=6e64e93e&"
var script = {}
import style0 from "./Page.vue?vue&type=style&index=0&id=6e64e93e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports